// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Text } from '@mantine/core';
import { formatCurrency } from '../utils/format';

const SIZE_MAP = {
  sm: 'sm',
  md: 'md',
  lg: 'xl',
} as const;

interface CurrencyDisplayProps {
  amount: number;
  currency?: string;
  colored?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function CurrencyDisplay({
  amount,
  currency = 'USD',
  colored = false,
  size = 'md',
}: CurrencyDisplayProps) {
  const color = colored
    ? amount > 0
      ? 'green'
      : amount < 0
        ? 'red'
        : undefined
    : undefined;

  return (
    <Text fw={500} c={color} size={SIZE_MAP[size]}>
      {formatCurrency(amount, currency)}
    </Text>
  );
}
